import React from "react";
import lazyLoad from "common/utils/lazyLoad";

export default lazyLoad(
  () => import(/* webpackChunkName: "ReportTemplatePillar" */ "."),
  <div>Reporting templates</div>,
);
